import React from 'react';
import { WorkflowNodeEditDrawer } from './components/workflow-node-edit-drawer';
import { WorkflowTriggerEditDrawer } from './components/workflow-trigger-edit-drawer';
import type { WorkflowEditLayout } from './components/workflow-edit-layout';
import type { DrillTarget } from './workflow-drill-context';

/** The config form for the active drill target. Returns null when nothing is
 * being edited. */
export const WorkflowDrillDetail: React.FC<{
  target: DrillTarget;
  layout?: WorkflowEditLayout;
}> = ({ target, layout = 'panel' }) => {
  if (target === null) {
    return null;
  }
  if (target.kind === 'node') {
    return <WorkflowNodeEditDrawer node={target.node} layout={layout} />;
  }
  return (
    <WorkflowTriggerEditDrawer open current={target.data} layout={layout} />
  );
};
